module.exports = __webpack_public_path__ + "static/img/4.41261f9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/eng/4.png
// module id = gAim
// module chunks = 0